/**
 * Tablo sütunları — API'den gelen alanlarla birebir (ID gizli, etiket/ display öncelikli).
 */
export const ENTITY_TABLE_CONFIG = {
    "sigorta-dosyalari": {
        columns: [
            "dosya_no",
            "muvekkil",
            "plaka",
            "sigorta_sirketi",
            "basvuru_konusu",
            "dosya_durumu",
            "tahkim_gecis",
            "on_tahkim_hedef_tarihi",
            "kalan_gun",
            "yatar_acilacak_mi",
            "son_not_ozeti",
            "eksik_evrak_sayisi",
            "avukat",
        ],
        labels: {
            dosya_no: "Dosya No",
            muvekkil: "Müvekkil",
            plaka: "Plaka",
            sigorta_sirketi: "Sigorta",
            basvuru_konusu: "Konu",
            dosya_durumu: "Durum",
            tahkim_gecis: "Tahkim geçiş",
            on_tahkim_hedef_tarihi: "Ön tah. hedef",
            kalan_gun: "Kalan",
            yatar_acilacak_mi: "Yatar",
            son_not_ozeti: "Notlar",
            eksik_evrak_sayisi: "Evrak",
            avukat: "Avukat",
        },
        displayKeys: {
            muvekkil: "muvekkil_ad_soyad",
            avukat: "avukat_label",
            basvuru_konusu: "basvuru_konusu_display",
            dosya_durumu: "dosya_durumu_display",
            sigorta_sirketi: "sigorta_sirketi_label",
            tahkim_gecis: "gecis_metin",
        },
        columnWidths: {
            dosya_no: "min-w-[5rem] max-w-[6.5rem] font-mono-jb text-[#F3E5AB]",
            muvekkil: "min-w-[7rem] max-w-[9rem]",
            plaka: "min-w-[4rem] max-w-[5rem] font-mono-jb",
            sigorta_sirketi: "min-w-[5.5rem] max-w-[8rem]",
            basvuru_konusu: "min-w-[4.5rem] max-w-[6.5rem]",
            dosya_durumu: "min-w-[4.5rem] max-w-[7rem]",
            tahkim_gecis: "min-w-[9rem] max-w-[14rem]",
            on_tahkim_hedef_tarihi: "min-w-[4.5rem] max-w-[5.5rem] font-mono-jb text-[11px]",
            kalan_gun: "min-w-[3rem] max-w-[3.5rem] text-center font-mono-jb",
            yatar_acilacak_mi: "min-w-[3rem] max-w-[3.5rem] text-center",
            son_not_ozeti: "min-w-[10rem] max-w-[14rem]",
            eksik_evrak_sayisi: "min-w-[2.75rem] max-w-[3rem] text-center",
            avukat: "min-w-[4.5rem] max-w-[6.5rem]",
        },
    },
    muvekkiller: {
        columns: [
            "ad",
            "soyad",
            "kimlik_tipi_display",
            "tc_kimlik_no",
            "telefon",
            "email",
            "aracilar_label",
            "araciya_odenen_miktar",
            "araci_hakedisi_odendi",
            "vekalet_durumu",
            "anlasma_orani",
            "olusturma_tarihi",
        ],
        labels: {
            ad: "Ad",
            soyad: "Soyad",
            kimlik_tipi_display: "Kimlik Türü",
            tc_kimlik_no: "TC / Vergi No",
            telefon: "Telefon",
            email: "E-posta",
            aracilar_label: "Aracı",
            araciya_odenen_miktar: "Hakediş",
            araci_hakedisi_odendi: "Ödendi",
            vekalet_durumu: "Vekalet",
            anlasma_orani: "Anlaşma %",
            olusturma_tarihi: "Kayıt",
        },
    },
    "deger-kaybi": {
        columns: [
            "dosya_no",
            "muvekkil_ad_soyad",
            "plaka",
            "rayic_degeri",
            "hasar_faturasi",
            "kusur_orani",
            "km",
            "baz_deger_kaybi",
            "deger_kaybi",
            "tahsil_edilen_dk",
            "dk_asama_label",
            "kaza_tarihi",
        ],
        labels: {
            dosya_no: "Dosya",
            muvekkil_ad_soyad: "Müvekkil",
            plaka: "Plaka",
            rayic_degeri: "Rayiç",
            hasar_faturasi: "Hasar F.",
            kusur_orani: "Kusur",
            km: "KM",
            baz_deger_kaybi: "Baz DK",
            deger_kaybi: "Gerçek DK",
            tahsil_edilen_dk: "Tahsil",
            dk_asama_label: "Aşama",
            kaza_tarihi: "Kaza",
        },
        columnWidths: {
            dosya_no: "min-w-[5.5rem] max-w-[7rem]",
            muvekkil_ad_soyad: "min-w-[7rem] max-w-[10rem]",
            plaka: "min-w-[4.5rem] max-w-[5.5rem]",
            rayic_degeri: "min-w-[5rem] text-right font-mono-jb text-[11px]",
            hasar_faturasi: "min-w-[5rem] text-right font-mono-jb text-[11px]",
            kusur_orani: "min-w-[3.25rem] text-center font-mono-jb text-[11px]",
            km: "min-w-[3.5rem] text-right font-mono-jb text-[11px]",
            baz_deger_kaybi: "min-w-[5rem] text-right font-mono-jb text-[11px]",
            deger_kaybi: "min-w-[5rem] text-right font-mono-jb text-[11px] text-[#F3E5AB]",
            tahsil_edilen_dk: "min-w-[5rem] text-right font-mono-jb text-[11px]",
            dk_asama_label: "min-w-[5.5rem] max-w-[7rem]",
            kaza_tarihi: "min-w-[4.5rem] max-w-[5.5rem]",
        },
    },
    evraklar: {
        columns: [
            "sigorta_dosyasi",
            "evrak_turu",
            "onay_durumu",
            "yuklenme_tarihi",
        ],
        labels: {
            sigorta_dosyasi: "Sigorta dosyası",
            evrak_turu: "Tür",
            onay_durumu: "Onay",
            yuklenme_tarihi: "Yükleme tarihi",
        },
    },
    odemeler: {
        columns: [
            "sigorta_dosyasi",
            "icra_takibi_label",
            "muvekkil_ad_soyad",
            "odeme_turu_display",
            "odeme_miktari",
            "toplam_masraf",
            "sigortali_hakedis",
            "mbs_hakedis",
            "odeme_yapildi",
            "kayit_tarihi",
        ],
        labels: {
            sigorta_dosyasi: "Dosya",
            icra_takibi_label: "İcra",
            muvekkil_ad_soyad: "Müvekkil",
            odeme_turu_display: "Tür",
            odeme_miktari: "Ödeme",
            toplam_masraf: "Masraf",
            sigortali_hakedis: "Sig. hakediş",
            mbs_hakedis: "MBS hakediş",
            odeme_yapildi: "Ödendi",
            kayit_tarihi: "Tarih",
        },
    },
    "masraf-detaylari": {
        columns: [
            "odeme_takibi",
            "masraf_turu_label",
            "miktar",
        ],
        labels: {
            odeme_takibi: "Ödeme Kaydı",
            masraf_turu_label: "Masraf Türü",
            miktar: "Tutar",
        },
    },
    faturalar: {
        columns: [
            "fatura_no",
            "sigorta_dosyasi",
            "toplam_tutar",
            "odeme_durumu",
            "fatura_tarihi",
        ],
        labels: {
            fatura_no: "Fatura No",
            sigorta_dosyasi: "Dosya",
            toplam_tutar: "Toplam",
            odeme_durumu: "Ödeme",
            fatura_tarihi: "Tarih",
        },
    },
    aracilar: {
        columns: ["ad", "email", "telefon", "hak_edis_miktari", "aktif", "kayit_tarihi"],
        labels: {
            ad: "Aracı",
            email: "E-posta",
            telefon: "Telefon",
            hak_edis_miktari: "Hakediş",
            aktif: "Aktif",
            kayit_tarihi: "Kayıt",
        },
    },
    randevular: {
        columns: ["baslik", "muvekkil", "baslangic", "bitis", "konum", "durum"],
        labels: {
            baslik: "Başlık",
            muvekkil: "Müvekkil",
            baslangic: "Başlangıç",
            bitis: "Bitiş",
            konum: "Konum",
            durum: "Durum",
        },
    },
    "gorusme-notlari": {
        columns: ["konu", "muvekkil", "gorusme_zamani", "kanal"],
        labels: {
            konu: "Konu",
            muvekkil: "Müvekkil",
            gorusme_zamani: "Zaman",
            kanal: "Kanal",
        },
    },
    hatirlatmalar: {
        columns: ["baslik", "hatirlatma_zamani", "yontem", "gonderildi_mi"],
        labels: {
            baslik: "Başlık",
            hatirlatma_zamani: "Zaman",
            yontem: "Yöntem",
            gonderildi_mi: "Gönderildi",
        },
    },
    "basvuru-formlari": {
        columns: ["ad_soyad", "telefon", "email", "kaza_tarihi", "durum", "tarih"],
        labels: {
            ad_soyad: "Ad Soyad",
            telefon: "Telefon",
            email: "E-posta",
            kaza_tarihi: "Kaza",
            durum: "Yanıtlandı",
            tarih: "Başvuru",
        },
    },
    "anlasmali-servisler": {
        columns: [
            "servis_ismi",
            "usta_ad_soyad",
            "telefon",
            "odenen_miktar",
            "muvekkil",
        ],
        labels: {
            servis_ismi: "Servis",
            usta_ad_soyad: "Usta",
            telefon: "Telefon",
            odenen_miktar: "Ödenen",
            muvekkil: "Müvekkil",
        },
    },
    "dilekce-kayitlari": {
        columns: ["dosya", "tur", "plaka", "muvekkil_ad", "olusturma_tarihi"],
        labels: {
            dosya: "Dosya",
            tur: "Tür",
            plaka: "Plaka",
            muvekkil_ad: "Müvekkil",
            olusturma_tarihi: "Tarih",
        },
    },
    "sigorta-sirketleri": {
        columns: ["ad", "email", "telefon"],
        labels: {
            ad: "Şirket",
            email: "E-posta",
            telefon: "Telefon",
        },
    },
    "sigorta-basvurulari": {
        columns: [
            "sigorta_dosyasi",
            "sigorta_sirketi",
            "konu",
            "durum",
            "olusturma_tarihi",
        ],
        labels: {
            sigorta_dosyasi: "Dosya",
            sigorta_sirketi: "Şirket",
            konu: "Konu",
            durum: "Durum",
            olusturma_tarihi: "Oluşturma",
        },
    },
    "tahkim-dosyalari": {
        columns: [
            "dosya_no",
            "muvekkil_ad_soyad",
            "plaka",
            "basvuru_no",
            "tahkim_asamasi_display",
            "hakem",
            "bilirkisi_adi",
            "dosya_durumu_display",
            "odeme_durumu_display",
            "son_odeme_tarihi",
        ],
        labels: {
            dosya_no: "Dosya No",
            muvekkil_ad_soyad: "Müvekkil",
            plaka: "Plaka",
            basvuru_no: "Başvuru No",
            tahkim_asamasi_display: "Tahkim Aşaması",
            hakem: "Hakem",
            bilirkisi_adi: "Bilirkişi",
            dosya_durumu_display: "Alt Durum",
            odeme_durumu_display: "Ödeme",
            son_odeme_tarihi: "Son Ödeme",
        },
    },
    icralar: {
        columns: [
            "icra_dosya_no",
            "dosya_no",
            "muvekkil_ad_soyad",
            "borc_tutari",
            "tahsil_edilen_tutar",
            "dosya_durumu_display",
            "icra_mudurlugu",
        ],
        labels: {
            icra_dosya_no: "İcra No",
            dosya_no: "Dosya No",
            muvekkil_ad_soyad: "Müvekkil",
            borc_tutari: "Borç",
            tahsil_edilen_tutar: "Tahsil",
            dosya_durumu_display: "Durum",
            icra_mudurlugu: "Müdürlük",
        },
    },
    vekaletler: {
        columns: [
            "id",
            "muvekkil_ad_soyad",
            "bitis_etiketi",
            "dosya_sayisi",
            "durum",
            "kalan_gun",
        ],
        labels: {
            id: "ID",
            muvekkil_ad_soyad: "Müvekkil",
            bitis_etiketi: "Bitiş",
            dosya_sayisi: "Dosya",
            durum: "Durum",
            kalan_gun: "Kalan",
        },
        displayKeys: {
            durum: "durum_display",
        },
        columnWidths: {
            id: "min-w-[3.25rem] max-w-[4.5rem] font-mono-jb text-[#F3E5AB]",
            muvekkil_ad_soyad: "min-w-[7rem] max-w-[11rem]",
            bitis_etiketi: "min-w-[5rem] max-w-[7rem]",
            dosya_sayisi: "min-w-[3rem] max-w-[3.5rem] text-center font-mono-jb",
            durum: "min-w-[4.5rem] max-w-[6rem]",
            kalan_gun: "min-w-[3.25rem] max-w-[4rem] text-center font-mono-jb",
        },
    },
    haberler: {
        columns: ["baslik", "kategori", "yayin_tarihi", "aktif"],
        labels: {
            baslik: "Başlık",
            kategori: "Kategori",
            yayin_tarihi: "Yayın",
            aktif: "Aktif",
        },
    },
    "audit-loglari": {
        columns: [
            "olusturma_tarihi",
            "kullanici_label",
            "model_adi",
            "islem_tipi_display",
            "nesne_temsili",
        ],
        labels: {
            olusturma_tarihi: "Zaman",
            kullanici_label: "Kullanıcı",
            model_adi: "Model",
            islem_tipi_display: "İşlem",
            nesne_temsili: "Nesne",
        },
    },
    "whatsapp-loglari": {
        columns: ["olusturma_tarihi", "telefon", "yon", "mesaj"],
        labels: {
            olusturma_tarihi: "Tarih",
            telefon: "Telefon",
            yon: "Yön",
            mesaj: "Mesaj",
        },
        columnWidths: {
            mesaj: "min-w-[12rem] max-w-[24rem]",
        },
    },
    "ai-gorevler": {
        columns: ["baslik", "hedef", "durum", "olusturma_tarihi"],
        labels: {
            baslik: "Başlık",
            hedef: "Hedef",
            durum: "Durum",
            olusturma_tarihi: "Tarih",
        },
    },
    "ai-oneryler": {
        columns: ["gorev", "uygulandi", "olusturma_tarihi"],
        labels: {
            gorev: "Görev",
            uygulandi: "Uygulandı",
            olusturma_tarihi: "Tarih",
        },
    },
    "hesap-hareketleri": {
        columns: ["tarih", "hesap", "hareket_turu", "tutar", "aciklama"],
        labels: {
            tarih: "Tarih",
            hesap: "Hesap",
            hareket_turu: "Tür",
            tutar: "Tutar",
            aciklama: "Açıklama",
        },
    },
};

/** Sütun değeri için display alanı (API EliteSerializer uyumlu). */
export function displayKeyFor(columnKey, rowKeys) {
    const keys = rowKeys || new Set();
    const candidates = [
        `${columnKey}_display`,
        `${columnKey}_label`,
        `${columnKey}_ad_soyad`,
        `${columnKey}_adi`,
        `${columnKey}_no`,
    ];
    for (const c of candidates) {
        if (keys.has(c)) return c;
    }
    return null;
}

export function getTableConfig(entityKey, entity) {
    const preset = ENTITY_TABLE_CONFIG[entityKey];
    if (preset) return preset;

    const cols = (entity?.fields || [])
        .filter(
            (f) =>
                f.name &&
                f.name !== "id" &&
                !f.hidden &&
                !f.readOnly &&
                f.type !== "textarea",
        )
        .slice(0, 10)
        .map((f) => f.name);

    const labels = {};
    for (const f of entity?.fields || []) {
        if (f.name) labels[f.name] = f.label || f.name;
    }

    return { columns: cols, labels };
}
